import React, { useState, useEffect, useContext } from 'react'
import List from '../../../components/list/list'
import Modal, { ModalTypes } from '../../../components/modal/modal'
import ThumbIcon from '../../../components/icons/thumb-icon'
import DownloadIcon from '../../../components/icons/download'
import RemoveIcon from '../../../components/icons/remove'
import { BackendContext, backendStatus } from '../../../backend/backend'
import { useToasts } from 'react-toast-notifications'
import { UserContext } from '../../user-context'
import { RemotizeType } from '../signup/signup'
import StopIcon from '../../../images/stop.svg'
import './firmware-custom.css'

const getDateString = (value) => {

    let date = new Date(value)

    return date.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false // 24h
    })
}

const remotizeDomain = process.env.REACT_APP_DOMAIN

let confirmFn = null

const UpdatefwCustomVersions = ({ firmwaresCustom, onAction }) => {
    const [firmwaresCustomLocal, setFirmwaresCustomLocal] = useState([...firmwaresCustom])
    const [confirmActivation, setConfirmActivation] = useState({ show: false, model: '', activeFw: true })
    const [confirmFwRemove, setConfirmFwRemove] = useState({ show: false, fwID: '' })
    
    const backend = useContext(BackendContext)
    const [user,] = useContext(UserContext)
    const { addToast } = useToasts()


    useEffect(() => {

        setFirmwaresCustomLocal([...firmwaresCustom])

        // eslint-disable-next-line 
    }, [firmwaresCustom])


    const getActiveFirmwareVersion = (model) => {
        for (let firmware of firmwaresCustomLocal) {
            if (firmware.model === model && firmware.useCustom === true) {
                return firmware.version
            }

        }

        return ''
    }

    const getActivateConfirmationModal = () => {

        let version = getActiveFirmwareVersion(confirmActivation.model)

        return (
            <Modal
                title='Atualização de dispositivos'
                show={confirmActivation.show}
                type={ModalTypes.CONFIRM}
                onDismissClick={confirmFn}
                content={<div style={{ width: '400px' }}>
                    <br></br>{
                        confirmActivation.activeFw ?
                            `A versão ${version} Customizada, estará disponível na aba de atualização.` :
                            `Ao desativar essa versão  ${version} customizadas todos os dispositivos  ${confirmActivation.model} voltarão para a ultima versão disponível na plataforma.`
                    }

                    Recomendamos que sempre mantenha seu parque atualizado.
                    <br></br>
                    <br></br>
                    <b>{`Deseja ${confirmActivation.activeFw ? "ativar" : "Desativar"} a versão ${version} ?`}</b>
                </div>}
                dismissText='Não, obrigado'
                confirmText={`Sim, quero ${confirmActivation.activeFw ? "ativar" : "Desativar"}`}
            ></Modal>
        )

    }

    const ActiveFwCustom = async (id, model, useCustom) => {

        let body = { 'useCustom': useCustom }

        let result = await backend.update(`firmwares_custom/${id}`, body)
        if (result.status === backendStatus.ERROR) {
            addToast(`Erro ao salvar informações de atualização para o modelo ${model}.`, {
                appearance: 'error',
                autoDismiss: true,
            })
            return
        }

        addToast(`Informações de atualização salvas com sucesso para o modelo ${model}.`, {
            appearance: 'success',
            autoDismiss: true,
        })

    }
    const getConfirmRemoveFw = () => {
        return (
            <Modal
                title='Remover firmware Customizado'
                show={confirmFwRemove.show}
                type={ModalTypes.CONFIRM}
                onDismissClick={confirmFn}
                content={<div style={{ width: '400px' }}>
                    <br></br>
                    Ao remover esse firmware, todos os dispositivos serão atualizados
                    para a ultima versão disponível na plataforma.
                    Recomendamos que sempre mantenha seu parque atualizado.
                    <br></br>
                    <br></br>
                    <b>Deseja Remover esse firmware Customizado?</b>
                </div>}
                dismissText='Não, obrigado'
                confirmText='Sim, quero remover'
            ></Modal>
        )

    }


    const RemoveFwCustom = async (id) => {
        let result = await backend.delete(`firmwares_custom/${id}`,)
        if (result.status === backendStatus.ERROR) {
            addToast('Erro ao salvar informações de atualização.', {
                appearance: 'error',
                autoDismiss: true,
            })
            return
        }

        addToast('Informações de atualização salvas com sucesso.', {
            appearance: 'success',
            autoDismiss: true,
        })
    }

    const canActivateFirmware = (model, id) => {
        const fwOfModel = firmwaresCustomLocal.filter(fw => fw.model === model)
        if (fwOfModel.length === 1) return true
        const alreadyActive = fwOfModel.some(fw => fw.useCustom && fw.id !== id)
        return !alreadyActive && fwOfModel.length > 1
    }

    const getActivateAction = (id, model, useCustom) => {

        if (user.type !== RemotizeType.ADMIN) return null

        const disabled = !canActivateFirmware(model, id)
        return (
            <button className='update-action update-activate' id='update-action-active'
                onClick={async (e) => {

                    e.preventDefault()

                    confirmFn = async (confirmed) => {
                        if (confirmed) {
                            await ActiveFwCustom(id, model, useCustom)
                        }

                        setConfirmActivation({ show: false, model: '', activeFw: true })
                        onAction()

                    }

                    setConfirmActivation({ show: true, model: model, activeFw: true })
                }}
                disabled={disabled}
            >
                <ThumbIcon size={20}></ThumbIcon>
                <span>ativar</span>
            </button>
        )
    }


    const getStopAction = (id, model, useCustom) => {

        if (user.type !== RemotizeType.ADMIN) return null
        return (
            <button className='update-action update-deactivate' id='update-action-stop'
                onClick={async (e) => {

                    e.preventDefault()

                    confirmFn = async (confirmed) => {
                        if (confirmed) {
                            await ActiveFwCustom(id, model, useCustom)
                        }
                        setConfirmActivation({ show: false, model: '', activeFw: false })
                        onAction()

                    }

                    setConfirmActivation({ show: true, model: model, activeFw: false })
                }}

            >
                <img alt='' src={StopIcon} width='18px'></img>
                <span>Desativar</span>
            </button>
        )
    }

    const getUpdateActions = (id, model, useCustom) => {
        return <div className='update-actions'>
            {useCustom ? getStopAction(id, model, !useCustom) : getActivateAction(id, model, !useCustom)}
        </div>
    }

    const getColumns = () => {
        let columns = [
            { header: 'Modelo', align: 'left' },
            { header: 'Versão', align: 'center' },
            { header: 'Ações', align: 'center' },
            { header: 'Usuário', align: 'center' },
            { header: 'Data de Criação', align: 'center' },
            { header: 'Download', align: 'center' },
            { header: 'Remover', align: 'center' },

        ]

        return columns
    }

    const getLines = () => {
        let lines = []
        for (let i = 0; i < firmwaresCustomLocal.length; i++) {
            let fw = firmwaresCustomLocal[i]
            let line = [
                <div className='item-custom' key={`model-${fw.id}`}>{fw.model}</div>,
                <div className='item-custom' key={`version-${fw.id}`}>{fw.version}</div>,
                getUpdateActions(fw.id, fw.model, fw.useCustom),
                <div className='item-custom' key={`who-${fw.id}`}>{fw.whoSended}</div>,
                <div className='item-custom' key={`date-${fw.id}`}>{getDateString(fw.createdAt)}</div>,
                getDownloadAction(fw.id),
                getRemoveAction(fw.id),
            ]

            lines.push(line)
        }

        return lines
    }

     
        const getRemoveAction = (fwID) => {
    
            return (
                <span
                    className={`itb-input-edit-icon clickable `}
                    id='update-action-removed'
                    onClick={async (e) => {
                        e.preventDefault()
    
                        confirmFn = async (confirmed) => {
                            if (confirmed) {
                                await RemoveFwCustom(fwID)
                            }
                            setConfirmFwRemove({ show: false, fwID: '' })
                            onAction()
                        }
                        setConfirmFwRemove({ show: true, fwID: fwID })
                    }
                    }
                >
                    <RemoveIcon size="18"></RemoveIcon>
                </span>
            )
        }
    
        const getDownloadAction = (fwID) => {
    
            return (
                <a
                    className={`itb-input-edit-icon clickable `}
                    id='update-action-removed'
                    href={`https://${remotizeDomain}/firmwares/${fwID}.bin`}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <DownloadIcon size="18"></DownloadIcon>
                </a>
            )
        }
    

    return (
        firmwaresCustomLocal.length === 0 ? <div className='update-no-devices'>
            Você ainda não possui dispositivos para atualizar
        </div> : <React.Fragment>

            {getActivateConfirmationModal()}
            {getConfirmRemoveFw()}

            <List
                columns={getColumns()}
                lines={getLines()}
            >
            </List>


        </React.Fragment>
    )


}

export default UpdatefwCustomVersions